import isEqual from 'react-fast-compare';
import defaultStencilTheme from '@amzn/stencil-design-tokens/js/web/theme/stencilTheme';
export const isDefaultStencilTheme = theme => {
  // user has not passed theme explicitly, meaning default stencil theme will be used.
  if (theme === undefined) return true;
  if (isEqual(theme, defaultStencilTheme)) {
    console.warn('Passing the default stencil theme through <StencilProvider theme={theme}/> is not required as it is imported internally.');
    return true;
  }
  return false;
};